import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBApply {
  // 获取应用菜单数据
  getApplyMenuData() {
    const url = '/api/db/site/app/list'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取快递详情
  getExpDetail() {
    const url = '/api/db/site/app/exp/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改快递状态
  postExpStatus(data) {
    const url = '/api/db/site/app/exp/update'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取ERP详情
  getERPDetail() {
    const url = '/api/db/site/app/erp/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改ERP状态
  postERPStatus(data) {
    const url = '/api/db/site/app/erp/update'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取供应商详情
  getSupplierDetail() {
    const url = '/api/db/site/app/supplier/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改供应商状态
  postSupplierStatus(data) {
    const url = '/api/db/site/app/supplier/update'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //获取供应商列表
  getSupplierList() {
    const url = '/api/db/site/app/supplier/list'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商审核
  postSupplierCheck(data) {
    const url = '/api/db/site/app/supplier/check'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 供应商启用禁用
  postSupplierUpdateStatus(data) {
    const url = '/api/db/site/app/supplier/update/status'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  //选品中心详情
  getSupplierSelectionDetail() {
    const url = '/api/db/site/app/selection/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 分销中心详情
  getSupplierInviteDetail() {
    const url = '/api/db/site/app/invite/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 分销中心更新
  postSupplierInviteUpdate(data) {
    const url = '/api/db/site/app/invite/update/status'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 选品中心更新
  postSupplierSelectionUpdate(data) {
    const url = '/api/db/site/app/selection/update'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取积分商城详情
  getPointsDetail() {
    const url = '/api/db/site/app/points/detail'
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改积分商城更新状态
  postExpStatus() {
    const url = '/api/db/site/app/points/update/status'
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 积分账户列表
  getPointsList(currentPage, name) {
    const url = `/api/db/points/xb/points/list?currentPage=${currentPage}&name=${name}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导出账户列表
  getPointsListExcel(name) {
    const url = `/api/download/xb/points/list?name=${name}`
    return axios.get(url, { responseType: 'blob' }).then((res) => {
      return Promise.resolve(res)
    })
  }
  // 充值
  postRecharge(data) {
    const url = '/api/db/points/xb/points/recharge'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 充值
  postDeduct(data) {
    const url = '/api/db/points/xb/points/deduct'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 积分账户明细
  getPointsListDetails(xbPointsId, currentPage) {
    const url = `/api/db/points/xb/points/details?xbPointsId=${xbPointsId}&currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取积分设置信息
  getPointsRule() {
    const url = `/api/db/points/detail/rule`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取积分设置商品列表
  getPointsSettingList(options) {
    let url = `/api/db/points/list/goods?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 新增商品中获取sku列表
  getPointsSettingSkuList(options) {
    let url = `/api/goods/item/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 编辑积分规则
  postMOdifyPointsSettintRule(data) {
    const url = '/api/db/points/update/rule'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改积分/件
  postModifyPoints(data) {
    const url = '/api/db/points/update/goods'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 删除积分商品
  removePointsGoods(data) {
    const url = '/api/db/points/remove/goods'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 新增积分商品
  addPointsGoods(data) {
    const url = '/api/db/points/add/goods'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改供应商权限
  postModifySupplierAuthority(data) {
    const url = '/api/db/site/app/supplier/update/authority'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 删除供应商
  postDelSupplierAuthority(data) {
    const url = '/api/db/site/app/supplier/del'
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBApply;
